/*
*  Contiene la información del producto 1
*/
export const defaultProducto1 = () => {
    return {
        id: '',
        nombre: '',
        fabricante_id: '',
        fabricante_texto: '',
        estado_id: '',
        estado_texto: '',
        pictogramas: [],
        sinPictograma: false,
        selectedSga: [],
        noun: '',
        riesgo_principal: '',
        riesgo_secundario: '',
        riesgo_secundario1: '',
        imagen_principal: '',
        imagen_secundario: '',
        imagen_secundario1: '',
        adjuntos: []
    }
}

/*
*  Contiene la información del producto 2
*/
export const defaultProducto2 = () => {
    return {
        id: '',
        nombre: '',
        fabricante_id: '',
        fabricante_texto: '',
        estado_id: '',
        estado_texto: '',
        pictogramas: [],
        sinPictograma: false,
        selectedSga: [],
        noun: '',
        riesgo_principal: '',
        riesgo_secundario: '',
        riesgo_secundario1: '',
        imagen_principal: '',
        imagen_secundario: '',
        imagen_secundario1: '',
        adjuntos: []
    }
}

/**
 * Contiene la información por defecto del sga
 *
 * @return {*}
 */
export const defaultSelectedSga = () => {
    return {
        categoriasfisicas: [],
        categoriassalud: [],
        categoriasambiental: [],
        categoriasNpeligrosas: []
    }
}

/**
 * Contiene la información por defecto de las naciones unidas de los productos
 *
 * @return {*}
 */
export const defaultUNProductos = () => {
    return {
        noun: '',
        riesgo_principal: '',
        riesgo_secundario: '',
        riesgo_secundario1: ''
    }
}

/*
*  Contiene la información del resultado de la compatibilidad
*/
export const defaultResultadoCompatibilidad = () => {
    return {
        key: '',
        text: '',
        color: '',
    }
}

/*
* Contiene la información de los filtros de búsqueda realizados en la paginación
*/
export const defaultFiltroResultados = () => {
    return {
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'DESC'
    }
}

/*
* Contiene la información de los filtros de los productos de la empresa (pagos)
*/
export const defaultFiltroPagos = () => {
    return {
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'DESC',
        buscar: '',
        id_fabricante: '',
        id_estado: ''
    }
}

/**
* Contiene la información de los filtros de los productos comparados
*/
export const defaultFiltrosProductosComparados = () => {
    return {
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'DESC',
        buscar: '',
        id_fabricante: '',
        id_estado: ''
    }
}

/**
 * Contiene la información de los filtros del historico de las comparaciones
 */
export const defaultFiltersHistory = () => {
    return {
        page: 1,
        perPage: 10,
        status: '',
        product: '',
    }
}

export default {
    empresas: [],
    selectedEmpresa: {
        id: '',
        nombre: '',
        productos: []
    },
    tipoMatriz: {
        tipo: ''
    },
    producto1: defaultProducto1(),
    producto2: defaultProducto2(),
    estados: [
        { value: 131, text: "Solido" },
        { value: 132, text: "Liquido" },
        { value: 133, text: "Gaseoso" }
    ],
    paso: 0,
    optprincipal: [],
    optsecundario: [],
    optsecundario1: [],
    homologacion_SGA: '',
    homologacion_UN: '',
    error: '',
    listadoResultados: [],
    registrarProducto1: false,
    registrarProducto2: false,
    consultarProducto1: true,
    consultarProducto1: true,
    esAdmin: false,
    total: {
        resultados: 0,
        productosPagos: 0,
        productosComparados: 0
    },
    filtroResultados: defaultFiltroResultados(),
    filtroProductosPagos: defaultFiltroPagos(),
    filtroProductosComparados: defaultFiltrosProductosComparados(),
    compatibilidad_un: 0,
    preguntas: [],
    resultados: [],
    productosComparados: [],
    productosGenerarMatriz: [],
    resultadoCompatibilidad: defaultResultadoCompatibilidad(),
    company_id: '',
    controlMatriz: [],
    history: [],
    filtersHistory: defaultFiltersHistory(),
}
